import React from 'react';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box
} from '@mui/material';
import { JobWorkMaterialWithDetails } from './types';

interface JobWorkMaterialsProps {
  materials: JobWorkMaterialWithDetails[];
  processMaterial: boolean;
}

const JobWorkMaterials: React.FC<JobWorkMaterialsProps> = ({ materials, processMaterial }) => {
  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Materials
      </Typography>
      
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Material Code</TableCell>
              <TableCell>Material Type</TableCell>
              <TableCell>Garment Part</TableCell>
              <TableCell>Size</TableCell>
              <TableCell align="right">Quantity</TableCell>
              <TableCell>UOM</TableCell>
              {processMaterial && (
                <>
                  <TableCell align="right">Rate</TableCell>
                  <TableCell align="right">Amount</TableCell>
                </>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {materials.length > 0 ? (
              materials.map((material, index) => (
                <TableRow key={index}>
                  <TableCell>{material.material?.material_code || material.materialDetails?.code || 'N/A'}</TableCell>
                  <TableCell>{material.material?.material_type || material.materialDetails?.type || 'N/A'}</TableCell>
                  <TableCell>{material.garmentPart}</TableCell>
                  <TableCell>{material.size}</TableCell>
                  <TableCell align="right">{material.quantity}</TableCell>
                  <TableCell>{material.uom}</TableCell>
                  {processMaterial && (
                    <>
                      <TableCell align="right">₹{material.rate || material.processingRate || 0}</TableCell>
                      <TableCell align="right">₹{(material.quantity * (material.rate || material.processingRate || 0)).toFixed(2)}</TableCell>
                    </>
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={processMaterial ? 8 : 6} align="center">
                  No materials found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      
      {materials.length > 0 && processMaterial && (
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Typography variant="subtitle1">
            Total: ₹{materials.reduce((sum, material) => 
              sum + (material.quantity * (material.rate || material.processingRate || 0)), 0
            ).toFixed(2)}
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default JobWorkMaterials; 